import React from 'react'

import { useSurveyQueryAvailableBrandGroups } from '~/hooks/useSurveyQuery'

export const useAvailableBrandGroups = () => {
  const brandGroups = useSurveyQueryAvailableBrandGroups()

  return React.useMemo(
    () => brandGroups.filter((brandGroup) => 0 < brandGroup.brands.length),

    [brandGroups],
  )
}
